import { useMemo } from 'react';
import Shepherd, { type Step, type TourOptions } from 'shepherd.js';

export const useShepherdTour = ({
  tourName,
  tourOptions = {},
  steps = [],
}: {
  tourName: string;
  tourOptions: TourOptions;
  steps?: Step[];
}) => {
  return useMemo(() => {
    const tourInstance = new Shepherd.Tour(tourOptions);

    tourInstance.addSteps(steps);

    return { tourInstance, tourName };
  }, [tourOptions, steps]);
};
